// JsFromRoutes CacheKey 4ab02fdf62f8a1db38b61562c11cb049
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  section: definePathHelper('get', '/pages/page_section/:page_id/:section_id'),
}
